import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
// Components
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
// Types
import { IOrderAudit } from '../../../models';
import { formatShortFriendlyDateWithTime } from '../../../helpers';
import { formatHistoryChangeField, formatHistoryChangeValue } from './OrderHistory';

interface IMobileOrderAudit {
  original: IOrderAudit;
}

export const MobileOrderHistory: FC<IMobileOrderAudit> = ({ original }) => {
  const classes = useStyles();
  const { createdDate, createdBy, ipAddress, originalValue, currentValue, propertyName } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">
            {formatShortFriendlyDateWithTime(createdDate)} - <Box component="span">{createdBy}</Box>
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Device/IP:
          </FormLabel>
          <Typography component="span" variant="body2">
            {ipAddress || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabelChange)}>
            Change:
          </FormLabel>
          <Typography component="span" variant="body2">
            {formatHistoryChangeField(propertyName) || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabelChange)}>
            Before Change:
          </FormLabel>
          <Typography component="span" variant="body2">
            {formatHistoryChangeValue(propertyName, originalValue) || '--'}
          </Typography>
        </div>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabelChange)}>
            After Change:
          </FormLabel>
          <Typography component="span" variant="body2">
            {formatHistoryChangeValue(propertyName, currentValue) || '--'}
          </Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  subLabelChange: {
    width: '100%',
    display: 'block'
  }
}));
